import { ApolloClient, NormalizedCacheObject } from "@apollo/client";
import { client } from "~/apollo/client";
import { CasesGraphqlDataSource } from "../../CasesOverview/casesGraphqlDataSource";

export class ClientLogGraphqlDataSource extends CasesGraphqlDataSource {
  clientId: number;

  constructor(
    clientId: number,
    arenaId: number | null = null,
    apolloClient: ApolloClient<NormalizedCacheObject> = client,
  ) {
    super(arenaId, apolloClient);
    this.clientId = clientId;
  }

  public buildQueryOptions(
    params: Parameters<CasesGraphqlDataSource["buildQueryOptions"]>[0],
  ): ReturnType<CasesGraphqlDataSource["buildQueryOptions"]> {
    const options = super.buildQueryOptions(params);
    if (options.variables) {
      options.variables.clientId = this.clientId;
    }
    return options;
  }
}
